import { Combobox } from '@/components/ui/combobox/combobox';
import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { HOTKEYS } from '@/lib/hotkeys';
import type { Deal } from '@/models/registry';
import { noop } from 'lodash';
import { DELIVERY_PREFERENCE_OPTIONS_MAP } from './deal-delivery-preference-selector';
import useUpdateDeliveryPreferenceMutation from './hooks/use-update-delivery-preference-mutation';

type DealDeliveryPreferenceCombobox = {
  dealId: Deal['id'];
  afterOnChange?: () => void;
  onSuccess?: (
    data: Deal,
    variables: { delivery_preference: Deal['delivery_preference'] },
  ) => void;
  onError?: (
    error: Error,
    variables: { delivery_preference: Deal['delivery_preference'] },
  ) => void;
};

function DealDeliveryPreferenceCombobox({
  dealId,
  afterOnChange,
  onSuccess,
  onError,
}: DealDeliveryPreferenceCombobox) {
  const { updateDeliveryPreferenceMutation } =
    useUpdateDeliveryPreferenceMutation({
      dealId,
      onSuccess,
      onError,
    });

  const handleDeliveryPreferenceChange = (
    newDeliveryPreference: Deal['delivery_preference'],
  ) => {
    updateDeliveryPreferenceMutation.mutate({
      delivery_preference: newDeliveryPreference,
    });

    afterOnChange?.();
  };

  return (
    <Combobox
      endAdornment={
        <KeyboardKeyIcon>{HOTKEYS.DEAL_DELIVERY_PREFERENCE}</KeyboardKeyIcon>
      }
      placeholder="Set delivery preference..."
      emptyMessage="No delivery preference found"
      options={DELIVERY_PREFERENCE_OPTIONS_MAP}
      onKeyDown={(e) => {
        const keyPressed = e.key;

        const option = DELIVERY_PREFERENCE_OPTIONS_MAP.find(
          (option) => option.hotkey === keyPressed,
        );

        if (option) {
          handleDeliveryPreferenceChange(option.value);
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      onChange={handleDeliveryPreferenceChange}
      setOpen={noop}
    ></Combobox>
  );
}

export default DealDeliveryPreferenceCombobox;
